import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { IPhoneCallCategory } from '../../../../extViewmodels';
import { usePhoneCallCategoryAssignmentMutation } from '../../../../queries/PhoneCall/usePhoneCallCategoryMutations';
import { CategoryListBuilder } from '../../CategoryListBuilder';
import { useTagList } from '../../LeadRuleModal/utils';
import { styleSheet } from '../styles';

interface IProps {
	phoneCallCategories: IPhoneCallCategory[];
	phoneCallId: string;
}

export const CallDetailsCategory: React.FC<IProps> = ({ phoneCallCategories, phoneCallId }) => {
	const [categories, addCategory, removeCategory, setCategories] = useTagList([]);
	const [categoryObjects, setCategoryObjects] = useState(null);

	const assignment = usePhoneCallCategoryAssignmentMutation();

	useEffect(() => {
		if (phoneCallCategories) {
			setCategoryObjects(phoneCallCategories);
			setCategories(phoneCallCategories?.map(c => c.name));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [phoneCallCategories]);

	const assignCategory = (categoryName: string, assigned: boolean) =>
		assignment.mutate(
			{ assigned, categoryName, phoneCallId },
			{
				onSuccess: phoneCall => {
					if (phoneCall?.categories) {
						setCategoryObjects(phoneCall.categories);
					}
				},
			}
		);

	const handleAddCategory = (category: string) => {
		addCategory(category);
		assignCategory(category, true);
	};

	const handleRemoveCategory = (category: string) => {
		removeCategory(category);
		assignCategory(category, false);
	};

	return (
		<div>
			<div className={css(styleSheet.sectionTitle)}>Call Categories</div>
			<CategoryListBuilder
				categoryObjects={categoryObjects}
				categories={categories}
				onAdd={handleAddCategory}
				onRemove={handleRemoveCategory}
			/>
		</div>
	);
};
